var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7343 5.61084C23.0584 5.61084 23.3694 5.73961 23.5986 5.96883C23.8279 6.19804 23.9566 6.50891 23.9566 6.83307V28.8331C23.9566 29.1572 23.8279 29.4682 23.5986 29.6974C23.3694 29.9264 23.0584 30.0552 22.7343 30.0552H3.17876C2.8546 30.0552 2.54373 29.9264 2.31452 29.6974C2.0853 29.4682 1.95654 29.1572 1.95654 28.8331V6.83307C1.95654 6.50891 2.0853 6.19804 2.31452 5.96883C2.54373 5.73961 2.8546 5.61084 3.17876 5.61084H22.7343Z",
    fill: "#FFDDA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9568 18.7144L20.4564 20.3461L17.8457 23.948L22.2836 24.2633L23.9568 23.4822V18.7144Z",
    fill: "#FFBC44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 9.27751C19.6666 9.60167 19.5378 9.91255 19.3086 10.1418C19.0795 10.371 18.7686 10.4997 18.4444 10.4997H7.44439C7.12023 10.4997 6.80937 10.371 6.58015 10.1418C6.35094 9.91255 6.22217 9.60167 6.22217 9.27751V5.61084H19.6666V9.27751Z",
    fill: "#FFBC44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9566 24.5552V28.8331C23.9566 29.1572 23.8279 29.4682 23.5986 29.6974C23.3694 29.9264 23.0584 30.0552 22.7343 30.0552H3.17876C2.8546 30.0552 2.54373 29.9264 2.31452 29.6974C2.0853 29.4682 1.95654 29.1572 1.95654 28.8331V6.83307C1.95654 6.50891 2.0853 6.19804 2.31452 5.96883C2.54373 5.73961 2.8546 5.61084 3.17876 5.61084H6.84542",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0679 5.61084H22.7345C23.0587 5.61084 23.3696 5.73961 23.5988 5.96883C23.828 6.19804 23.9567 6.50891 23.9567 6.83307V11.1108",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6863 4.38867H17.8457C18.1699 4.38867 18.4808 4.51744 18.7099 4.74664C18.9392 4.97586 19.0679 5.28674 19.0679 5.61089V6.83311C19.0679 7.15727 18.9392 7.46814 18.7099 7.69735C18.4808 7.92656 18.1699 8.05534 17.8457 8.05534H8.06792C7.74377 8.05534 7.43289 7.92656 7.20368 7.69735C6.97448 7.46814 6.8457 7.15727 6.8457 6.83311V5.61089C6.8457 5.28674 6.97448 4.97586 7.20368 4.74664C7.43289 4.51744 7.74377 4.38867 8.06792 4.38867H11.2335",
    fill: "#E4F1F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6863 4.38867H17.8457C18.1699 4.38867 18.4808 4.51744 18.7099 4.74664C18.9392 4.97586 19.0679 5.28674 19.0679 5.61089V6.83311C19.0679 7.15727 18.9392 7.46814 18.7099 7.69735C18.4808 7.92656 18.1699 8.05534 17.8457 8.05534H8.06792C7.74377 8.05534 7.43289 7.92656 7.20368 7.69735C6.97448 7.46814 6.8457 7.15727 6.8457 6.83311V5.61089C6.8457 5.28674 6.97448 4.97586 7.20368 4.74664C7.43289 4.51744 7.74377 4.38867 8.06792 4.38867H11.2335",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9564 5.611C13.319 5.611 13.6735 5.50348 13.9749 5.30204C14.2764 5.10057 14.5115 4.81427 14.6501 4.47927C14.7889 4.14427 14.8253 3.77564 14.7545 3.42001C14.6837 3.06437 14.5091 2.73771 14.2528 2.48131C13.9964 2.22491 13.6696 2.05031 13.314 1.97956C12.9584 1.90883 12.5898 1.94513 12.2548 2.08389C11.9198 2.22265 11.6335 2.45764 11.432 2.75913C11.2306 3.06061 11.123 3.41508 11.123 3.77767C11.123 4.26391 11.3162 4.73023 11.66 5.07403C12.0038 5.41785 12.4702 5.611 12.9564 5.611Z",
    fill: "#98B7C0",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 12.9443H20.2897",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 17.8335H17.1925",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 22.7222H15.38",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1234 22.7224L17.8457 23.9445L19.0678 19.6668L26.3792 12.3554C26.7866 11.961 27.3326 11.7426 27.8998 11.7471C28.4668 11.7518 29.0092 11.979 29.4102 12.38C29.8112 12.7809 30.0385 13.3234 30.043 13.8904C30.0476 14.4574 29.8292 15.0036 29.4348 15.411L22.1234 22.7224Z",
    fill: "#FFEF5E",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseActionIcon);
export default __webpack_public_path__ + "static/media/CourseActionIcon.ad9531b70c126865a808bd6771a28083.svg";
export { ForwardRef as ReactComponent };